import {
  Component,
  HostBinding,
  Input,
  OnInit,
  OnChanges,
  Output,
  EventEmitter,
} from '@angular/core';
import { NavItem } from './nav-item';
import { Router } from '@angular/router';
import { NavService } from '../../../../../services/nav.service';
import {
  animate,
  state,
  style,
  transition,
  trigger,
} from '@angular/animations';
import { TranslateModule } from '@ngx-translate/core';
import { TablerIconsModule } from 'angular-tabler-icons';
import { MaterialModule } from 'src/app/material.module';
import { CommonModule } from '@angular/common';
import { CoreService } from 'src/app/services/core.service';
import { AppSettings } from 'src/app/config';
import { UserService } from 'src/app/services/user.service';

@Component({
  selector: 'app-nav-item',
  standalone: true,
  imports: [TranslateModule, TablerIconsModule, MaterialModule, CommonModule],
  templateUrl: './nav-item.component.html',
  styleUrls: [],
  animations: [
    trigger('indicatorRotate', [
      state('collapsed', style({ transform: 'rotate(0deg)' })),
      state('expanded', style({ transform: 'rotate(180deg)' })),
      transition(
        'expanded <=> collapsed',
        animate('225ms cubic-bezier(0.4,0.0,0.2,1)')
      ),
    ]),
  ],
})
export class AppNavItemComponent implements OnChanges {
  @Output() toggleMobileLink: any = new EventEmitter<void>();
  @Output() notify: EventEmitter<boolean> = new EventEmitter<boolean>();
  @Output() optionsChange = new EventEmitter<AppSettings>();

  expanded: any = false;
  disabled: any = false;
  twoLines: any = false;
  @HostBinding('attr.aria-expanded') ariaExpanded = this.expanded;
  @Input() item: NavItem | any;
  @Input() depth: any;

  options = this.settings.getOptions();

  constructor(
    public navService: NavService, 
    public router: Router, 
    private settings: CoreService,
    private userService: UserService
  ) {
    if (this.depth === undefined) {
      this.depth = 0;
    }
  }

  ngOnChanges() {
    this.navService.currentUrl.subscribe((url: string) => {
      if (this.item.route && url) {
        // console.log(`Checking '/${this.item.route}' against '${url}'`);
        this.expanded = url.indexOf(`/${this.item.route}`) === 0;
        this.ariaExpanded = this.expanded;
        //console.log(`${this.item.route} is expanded: ${this.expanded}`);
      }
    });
  }

  onItemSelected(event: Event, item: NavItem) {
    if (!item.children || !item.children.length) {
      if (item.route) {
        this.router.navigate([item.route]);
        //scroll
        window.scroll({
          top: 0,
          left: 0,
          behavior: 'smooth',
        });
      } else {
        this.changeTheme(item);
      }

    }
    if (item.children && item.children.length) {
      event.stopPropagation();
      this.expanded = !this.expanded;
      item!.expanded = this.expanded;
    }

    if (!this.expanded) {
      if (window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
  }

  onSubItemSelected(item: NavItem) {
    if (!item.children || !item.children.length) {
      if (this.expanded && window.innerWidth < 1024) {
        this.notify.emit();
      }
    }
    if (!item.route) {
      this.changeTheme(item);
    }
  }
  async changeTheme(item: NavItem) {
    var user = JSON.parse(localStorage.getItem('user') || '{}')
    this.options.theme = (item.displayName)!.toLowerCase();
    var userTheme = (item.displayName)!.toLowerCase() == 'light' ? 1 : 2
    await this.userService.setUserTheme({theme: userTheme})
    if (user) {
      user.theme = userTheme;
      localStorage.setItem('user', JSON.stringify(user));
    }
    this.optionsChange.emit(this.options);
    this.expanded = false;
    item.expanded = false;
  }
  sameTheme(item: NavItem) {
    return this.options.theme == (item.displayName)!.toLowerCase();
  }
}
